import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";
import { validateClientDocumentUpload } from "./clientDocumentUploadPolicy";

const API_URL = config.API_URL;

const multipartHeaders = () => {
  const configuredHeaders = authHeader({ contentType: "multipart/form-data" }) || {};
  const headers = { ...configuredHeaders };
  delete headers["Content-Type"];
  return headers;
};

const create = (values) => {
  const validationError = validateClientDocumentUpload(values.myFiles);
  if (validationError) {
    throw { response: { status: 422, data: { message: validationError } } };
  }
  const formData = new FormData();
  for (let value in values) {
    if (value === "client_id") continue;
    if (["myFiles"].includes(value) && values[value] && typeof values[value] === "object") {
      values.myFiles.forEach((document) => {
        formData.append("document", document);
      });
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/clientdocument/store";
  formData.append("client_id", values.client_id);
  return axios.post(API_URL + action, formData, { headers: multipartHeaders() });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/clientdocument/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  formData.append("client_id", values.client_id);
  return axios.post(API_URL + action, formData, { headers: multipartHeaders() });
};

const view = (values = {}) => {
  const request = buildClientHistoryListRequest("afterlogin/clientdocument/view", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const download = ({ id }) => axios.get(
  `${API_URL}afterlogin/clientdocument/download/${id}`,
  { headers: authHeader(), responseType: "blob" },
);

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/clientdocument/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const clientdocumentApiController = {
  create,
  download,
  update,
  view,
  deleted,
};
export default clientdocumentApiController;
